import React, { useState } from 'react';
import { auth } from '../firebase/firebaseconfig';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, Zap, AlertCircle } from 'lucide-react';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/admin-panel');
    } catch (err) {
      setError("Invalid Credentials. Please try again.");
      
    }
  };

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="card border-0 shadow-lg rounded-4 p-5" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="text-center mb-4">
          <div className="bg-success-subtle d-inline-block p-3 rounded-circle mb-3">
            <Zap className="text-success" size={32} fill="currentColor" />
          </div>
          <h3 className="fw-bold text-dark">Admin Portal</h3>
          <p className="text-muted small">Denial Enterprise Management</p>
        </div>

        {error && (
          <div className="alert alert-danger d-flex align-items-center small py-2 rounded-3 border-0">
            <AlertCircle size={16} className="me-2" /> {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="small fw-bold text-muted mb-1">Email Address</label>
            <div className="input-group">
              <span className="input-group-text bg-white border-end-0"><Mail size={16} /></span>
              <input 
                type="email" 
                className="form-control border-start-0 ps-0" 
                placeholder="admin@denial.com"
                onChange={(e) => setEmail(e.target.value)}
                required 
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="small fw-bold text-muted mb-1">Password</label>
            <div className="input-group">
              <span className="input-group-text bg-white border-end-0"><Lock size={16} /></span>
              <input 
                type="password" 
                className="form-control border-start-0 ps-0" 
                placeholder="••••••••"
                onChange={(e) => setPassword(e.target.value)}
                required 
              />
            </div>
          </div>

          <button type="submit" className="btn btn-success w-100 py-3 fw-bold rounded-pill shadow-sm">
            SECURE LOGIN
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;